import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';

import { Button } from '../../../ui';

export const Ownership = ({
  setCurrentStep,
  isLoading,
}: {
  setCurrentStep: Dispatch<
    SetStateAction<
      | 'REQUIREMENTS'
      | 'INTRODUCTION'
      | 'CAPITAL TYPES'
      | 'GROWTH PLAN'
      | 'FINANCIALS'
      | 'OWNERSHIP'
      | 'EBITDA'
      | 'AMOUNT NEEDED'
      | 'BREAKDOWN'
      | 'REVIEW'
      | 'CONFIRMATION'
    >
  >;
  isLoading: boolean;
}) => {
  return (
    <div className="flex gap-8">
      <div className="flex flex-col gap-4 flex-1">
        <div className="flex flex-col gap-2">
          <span className="text-2xl font-bold">Ownership Breakdown</span>
          <span className="text-base font-normal">
            Please provide ownership breakdown by percentage.
          </span>
          <div className="flex gap-6">
            <div className="flex-grow rounded-2xl  border border-primary-50 bg-primary-25 py-2 px-4 flex gap-2">
              <span>Founders</span>
            </div>
            <Image
              src={'/icons/arrow-narrow-right.svg'}
              width={20}
              height={20}
              alt=""
            />
            <div className="flex items-center gap-2 bg-gray-100 rounded-2xl px-4">
              <Image
                src="/icons/percent.svg"
                alt="Prefix Icon"
                width={20}
                height={20}
              />
              <input
                type="text"
                className="w-28 bg-gray-100 focus:bg-none focus:border-none"
                placeholder="Enter number"
              />
            </div>
          </div>
          <div className="flex gap-6">
            <div className="flex-grow rounded-2xl  border border-primary-50 bg-primary-25 py-2 px-4 flex gap-2">
              <span>Management</span>
            </div>
            <Image
              src={'/icons/arrow-narrow-right.svg'}
              width={20}
              height={20}
              alt=""
            />
            <div className="flex items-center gap-2 bg-gray-100 rounded-2xl px-4">
              <Image
                src="/icons/percent.svg"
                alt="Prefix Icon"
                width={20}
                height={20}
              />
              <input
                type="text"
                className="w-28 bg-gray-100 focus:bg-none focus:border-none"
                placeholder="Enter number"
              />
            </div>
          </div>
          <div className="flex gap-6">
            <div className="flex-grow rounded-2xl  border border-primary-50 bg-primary-25 py-2 px-4 flex gap-2">
              <span>High Net Worth Individuals</span>
            </div>
            <Image
              src={'/icons/arrow-narrow-right.svg'}
              width={20}
              height={20}
              alt=""
            />
            <div className="flex items-center gap-2 bg-gray-100 rounded-2xl px-4">
              <Image
                src="/icons/percent.svg"
                alt="Prefix Icon"
                width={20}
                height={20}
              />
              <input
                type="text"
                className="w-28 bg-gray-100 focus:bg-none focus:border-none"
                placeholder="Enter number"
              />
            </div>
          </div>
          <div className="flex gap-6">
            <div className="flex-grow rounded-2xl  border border-primary-50 bg-primary-25 py-2 px-4 flex gap-2">
              <span>Private Equity</span>
            </div>
            <Image
              src={'/icons/arrow-narrow-right.svg'}
              width={20}
              height={20}
              alt=""
            />
            <div className="flex items-center gap-2 bg-gray-100 rounded-2xl px-4">
              <Image
                src="/icons/percent.svg"
                alt="Prefix Icon"
                width={20}
                height={20}
              />
              <input
                type="text"
                className="w-28 bg-gray-100 focus:bg-none focus:border-none"
                placeholder="Enter number"
              />
            </div>
          </div>
          <div className="flex gap-6">
            <div className="flex-grow rounded-2xl  border border-primary-50 bg-primary-25 py-2 px-4 flex gap-2">
              <span>Other</span>
            </div>
            <Image
              src={'/icons/arrow-narrow-right.svg'}
              width={20}
              height={20}
              alt=""
            />
            <div className="flex items-center gap-2 bg-gray-100 rounded-2xl px-4">
              <Image
                src="/icons/percent.svg"
                alt="Prefix Icon"
                width={20}
                height={20}
              />
              <input
                type="text"
                className="w-28 bg-gray-100 focus:bg-none focus:border-none"
                placeholder="Enter number"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2"></div>
        <div className="flex gap-3">
          <div>
            <Button
              text="Back"
              variant={isLoading ? 'disabled' : 'secondary'}
              onClick={() => setCurrentStep('FINANCIALS')}
            />
          </div>
          <div>
            <Button
              text="Continue"
              variant={isLoading ? 'disabled' : 'primary'}
              suffixIcon="/icons/arrow_right.svg"
              onClick={() => setCurrentStep('EBITDA')}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-1 justify-center">
        <Image
          src="/create_cr.png"
          alt="Supplier Request Image"
          priority
          width={512}
          height={584}
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};
